var map = {
	"./arrow-right.svg": 555,
	"./chevron-down.svg": 698,
	"./chevron-right.svg": 260,
	"./chevron-up.svg": 352,
	"./digitalization.svg": 764,
	"./download-cloud.svg": 791,
	"./envelope.svg": 219,
	"./interoperability.svg": 495,
	"./location.svg": 668,
	"./logo.svg": 467,
	"./medicalc.svg": 654,
	"./mex.svg": 689,
	"./mlabs.svg": 376,
	"./mmobile.svg": 443,
	"./mobility.svg": 99,
	"./mpacs.svg": 888,
	"./mpatient.svg": 336,
	"./paperless.svg": 824,
	"./phone.svg": 694,
	"./send.svg": 410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;